<template>
  <div class="accordion" role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab" v-b-modal.modalAddAction
      v-if="this.checkTicketEditable(this.user, ticket) && (this.checkUserInTicket(this.user, ticket) || this.checkManagerInGroup(this.user, this.ticket.grup.id))">
        <AddAction :ticket="ticket" :title="'Afegir informació'"
        :transition="this.ticket.estat.nom === 'needinfo' && this.checkUserInTicket(this.user, ticket) ? 'addedinfo' : null"/>
        <b-button block href="#" variant="dark">
          <font-awesome-icon class="mr-3" :icon="['fas', 'plus']" />
          Afegir informació
        </b-button>
      </b-card-header>
    </b-card>
    <span v-if="this.actionsByDate.length > 0">
      <b-card no-body class="mb-1" v-for="action in this.actionsByDate" :key="action['id']">
        <b-card-header header-tag="header" role="tab" class="text-center"
        block :header-bg-variant="action.private ? 'secondary' : 'light'" :header-text-variant="action.private ? 'white' : 'default'">
          <b-badge v-if="action.private" variant="dark" class="float-left d-none d-sm-block">PRIVADA</b-badge>
          <font-awesome-icon :icon="['fas', 'eye-slash']" v-if="action.private"/>
          <font-awesome-icon :icon="['fas', 'tools']" v-else-if="ticket.gestors.some(g => g.codi_xarxa == action.usuari)"/>
          <font-awesome-icon :icon="['fas', 'user']" v-else/>
          {{ action.data_accio | humanFriendlyDate }} - {{ action.usuari }}
          <b-button v-if="user.id == action.usuari && managerModifyStateShown(ticket)" class="float-right mt-n1 mb-n1"
            :variant="action.private ? 'outline-light' : 'outline-dark'" @click="deleteAction(action.id)" size="sm">
            <font-awesome-icon size="sm" :icon="['far', 'trash-alt']"/>
          </b-button>
        </b-card-header>
        <b-card-body class="text-left">
          <b-card-text>
            <ReadOnlyEditor :editorText="action.descripcio"/>
          </b-card-text>
          <div v-if="action.files" >
            <b-card-text class="font-weight-bold">Fitxers adjunts:</b-card-text>
            <b-card-text>
              <FilesPreview v-if="action.files" :files="files.filter(file => action.files.includes(file.name))" :ticket_id="ticket.id"/>
            </b-card-text>
          </div>
        </b-card-body>
      </b-card>
    </span>
    <b-card no-body class="mb-1" v-else>
      <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block href="#"  variant="default">
              No hi ha cap intervenció</b-button>
        </b-card-header>
    </b-card>

  </div>
</template>

<script>
import AddAction from '@/components/AddAction'
import FilesPreview from '@/components/FilesPreview'
import moment from 'moment'
import ReadOnlyEditor from '@/components/ReadOnlyEditor'

export default {
  components: {
    AddAction,
    FilesPreview,
    ReadOnlyEditor
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    files: {
      required: true,
      type: Array
    }
  },
  computed: {
    actionsByDate: function () {
      if (this.checkManagerInGroup(this.user, this.ticket.grup.id)) {
        return this.ticket.accions.sort((a, b) => new Date(b.data_accio) - new Date(a.data_accio))
      } else {
        return this.ticket.accions.filter(action => !action.private).sort((a, b) => new Date(b.data_accio) - new Date(a.data_accio))
      }
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  filters: {
    humanFriendlyDate (date) {
      return moment.utc(date).format('DD/MM/YYYY HH:mm:ss')
    }
  },
  methods: {
    deleteAction (actionId) {
      this.$snotify.confirm('Eliminaràs aquesta intervenció', 'Estàs segur/a?', {
        showProgressBar: false,
        closeOnClick: false,
        buttons: [
          {
            text: 'Si',
            action: (toast) => {
              this.$store.dispatch('deleteAction', { ticketId: this.ticket.id, actionId: actionId })
              this.$snotify.remove(toast.id)
            },
            bold: false
          },
          {
            text: 'No',
            action: (toast) => {
              this.$snotify.remove(toast.id)
            },
            bold: false
          }
        ]
      })
    }
  }
}
</script>

<style scoped>
</style>
